export default __webpack_public_path__ + "static/media/Community2.f21aa5e4.jpg";